import type { User } from "../state/user";
import type { Invite } from "../state/invite";
import InviteId from "../state/InviteId";
import { isNotEmpty } from "./stringUtil";

export const isInvite = (input: User | Invite): input is Invite => input.id instanceof InviteId;

// DEV-6760 Implementation needs to be improved based on requirements (still need to be made)
export const resolveInitials = (user: User | Invite): string =>
  isInvite(user) ? resolveInitialsFromEmail(user.emailAddress) : resolveInitialsFromName(user.firstName, user.lastName);

export const resolveInitialsFromName = (firstName?: string, lastName?: string) => {
  const trimmedFirstName = firstName?.trim();
  const trimmedLastName = lastName?.trim();

  return isNotEmpty(trimmedFirstName) && isNotEmpty(trimmedLastName) ? trimmedFirstName[0] + trimmedLastName[0] : "??";
};

// DEV-6760 Implementation needs to be improved based on requirements (still need to be made)
export const resolveFullName = (user: Pick<User, "firstName" | "lastName">): string =>
  resolveFullNameFromName(user.firstName?.trim(), user.lastName?.trim());

export const resolveFullNameFromName = (firstName?: string, lastName?: string) =>
  isNotEmpty(firstName) && isNotEmpty(lastName) ? firstName + " " + lastName : "??";

export const resolveUserOrInviteName = (
  isInvited: boolean,
  user: { emailAddress?: string; firstName?: string; lastName?: string },
): string => (isInvited ? (user.emailAddress ?? "??") : resolveFullName(user));

export const resolveInitialsFromEmail = (email: string) => {
  const atIndex = email.indexOf("@");
  if (atIndex <= 0 || atIndex >= email.length - 1) {
    return "??";
  }

  return email[0] + email[atIndex + 1];
};
